import HotNew from './HotNew/HotNew';
import Sale from './Sale';
import Style from './Style';

const Main = () => {
  return (
    <main className="Homepage__main">
      <HotNew />
      <Sale />
    </main>
  );
};

export default Main;
